import PropTypes from "prop-types";
import { usd } from "../../../util/formatCurrency.js";
import { UploadIcon } from "./Icons.jsx";
import s from "./CustomUploadBanner.module.css";
import { Button } from "../../../themeV2";

export default function CustomUploadBanner({ products, onGetStarted }) {
  if (products.length === 0) return null;

  const prices = products.map((p) => p._totalPrice);
  const min = Math.min(...prices);
  const max = Math.max(...prices);
  const priceLabel = min === max ? usd(min) : `${usd(min)} – ${usd(max)}`;

  return (
    <div className={s.container}>
      <div className={s.banner}>
        <div className={s.icon} aria-hidden="true">
          <UploadIcon />
        </div>
        <div className={s.body}>
          <p className={s.title}>Custom artwork signing</p>
          <p className={s.subtitle}>
            Upload your own artwork and have it personally signed
          </p>
          <p className={s.price}>From {priceLabel}</p>
        </div>
        <Button
          size="sm"
          fullWidth
          className={s.cta}
          onClick={onGetStarted}
          aria-label="Get started with custom artwork signing"
        >
          Get started
        </Button>
      </div>
    </div>
  );
}

CustomUploadBanner.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      _totalPrice: PropTypes.number.isRequired,
    }),
  ).isRequired,
  onGetStarted: PropTypes.func.isRequired,
};
